/* generated by Svelte v3.31.0 */
import { SvelteComponent, binding_callbacks, create_slot, detach, element, init, insert, safe_not_equal, set_custom_element_data, transition_in, transition_out, update_slot } from "svelte/internal";
import { define } from "../lib";
import { VmDefaultControls, VmCaptionControl, VmControl, VmIcon, VmTooltip, VmControlGroup, VmControlSpacer, VmControls, VmCurrentTime, VmTime, VmEndTime, VmFullscreenControl, VmLiveIndicator, VmMuteControl, VmPipControl, VmPlaybackControl, VmScrim, VmScrubberControl, VmSlider, VmSettingsControl, VmTimeProgress, VmVolumeControl } from "@vime/core";
import { createEventDispatcher, onMount } from "svelte";
function create_fragment(ctx) {
    let vm_default_controls;
    let current;
    const default_slot_template = /*#slots*/ ctx[15].default;
    const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[14], null);
    return {
        c() {
            vm_default_controls = element("vm-default-controls");
            if (default_slot)
                default_slot.c();
            set_custom_element_data(vm_default_controls, "class", /*className*/ ctx[0]);
            set_custom_element_data(vm_default_controls, "style", /*style*/ ctx[1]);
            set_custom_element_data(vm_default_controls, "active-duration", /*activeDuration*/ ctx[2]);
            set_custom_element_data(vm_default_controls, "wait-for-playback-start", /*waitForPlaybackStart*/ ctx[3]);
            set_custom_element_data(vm_default_controls, "hide-when-paused", /*hideWhenPaused*/ ctx[4]);
            set_custom_element_data(vm_default_controls, "hide-on-mouse-leave", /*hideOnMouseLeave*/ ctx[5]);
            set_custom_element_data(vm_default_controls, "theme", /*theme*/ ctx[6]);
            set_custom_element_data(vm_default_controls, "is-mobile", /*isMobile*/ ctx[7]);
            set_custom_element_data(vm_default_controls, "is-live", /*isLive*/ ctx[8]);
            set_custom_element_data(vm_default_controls, "is-audio-view", /*isAudioView*/ ctx[9]);
            set_custom_element_data(vm_default_controls, "is-video-view", /*isVideoView*/ ctx[10]);
        },
        m(target, anchor) {
            insert(target, vm_default_controls, anchor);
            if (default_slot) {
                default_slot.m(vm_default_controls, null);
            }
            /*vm_default_controls_binding*/ ctx[16](vm_default_controls);
            current = true;
        },
        p(ctx, [dirty]) {
            if (default_slot) {
                if (default_slot.p && dirty & /*$$scope*/ 16384) {
                    update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[14], dirty, null, null);
                }
            }
            if (!current || dirty & /*className*/ 1) {
                set_custom_element_data(vm_default_controls, "class", /*className*/ ctx[0]);
            }
            if (!current || dirty & /*style*/ 2) {
                set_custom_element_data(vm_default_controls, "style", /*style*/ ctx[1]);
            }
            if (!current || dirty & /*activeDuration*/ 4) {
                set_custom_element_data(vm_default_controls, "active-duration", /*activeDuration*/ ctx[2]);
            }
            if (!current || dirty & /*waitForPlaybackStart*/ 8) {
                set_custom_element_data(vm_default_controls, "wait-for-playback-start", /*waitForPlaybackStart*/ ctx[3]);
            }
            if (!current || dirty & /*hideWhenPaused*/ 16) {
                set_custom_element_data(vm_default_controls, "hide-when-paused", /*hideWhenPaused*/ ctx[4]);
            }
            if (!current || dirty & /*hideOnMouseLeave*/ 32) {
                set_custom_element_data(vm_default_controls, "hide-on-mouse-leave", /*hideOnMouseLeave*/ ctx[5]);
            }
            if (!current || dirty & /*theme*/ 64) {
                set_custom_element_data(vm_default_controls, "theme", /*theme*/ ctx[6]);
            }
            if (!current || dirty & /*isMobile*/ 128) {
                set_custom_element_data(vm_default_controls, "is-mobile", /*isMobile*/ ctx[7]);
            }
            if (!current || dirty & /*isLive*/ 256) {
                set_custom_element_data(vm_default_controls, "is-live", /*isLive*/ ctx[8]);
            }
            if (!current || dirty & /*isAudioView*/ 512) {
                set_custom_element_data(vm_default_controls, "is-audio-view", /*isAudioView*/ ctx[9]);
            }
            if (!current || dirty & /*isVideoView*/ 1024) {
                set_custom_element_data(vm_default_controls, "is-video-view", /*isVideoView*/ ctx[10]);
            }
        },
        i(local) {
            if (current)
                return;
            transition_in(default_slot, local);
            current = true;
        },
        o(local) {
            transition_out(default_slot, local);
            current = false;
        },
        d(detaching) {
            if (detaching)
                detach(vm_default_controls);
            if (default_slot)
                default_slot.d(detaching);
            /*vm_default_controls_binding*/ ctx[16](null);
        }
    };
}
define("vm-default-controls", VmDefaultControls);
define("vm-caption-control", VmCaptionControl);
define("vm-control", VmControl);
define("vm-icon", VmIcon);
define("vm-tooltip", VmTooltip);
define("vm-control-group", VmControlGroup);
define("vm-control-spacer", VmControlSpacer);
define("vm-controls", VmControls);
define("vm-current-time", VmCurrentTime);
define("vm-time", VmTime);
define("vm-end-time", VmEndTime);
define("vm-fullscreen-control", VmFullscreenControl);
define("vm-live-indicator", VmLiveIndicator);
define("vm-mute-control", VmMuteControl);
define("vm-pip-control", VmPipControl);
define("vm-playback-control", VmPlaybackControl);
define("vm-scrim", VmScrim);
define("vm-scrubber-control", VmScrubberControl);
define("vm-slider", VmSlider);
define("vm-settings-control", VmSettingsControl);
define("vm-time-progress", VmTimeProgress);
define("vm-volume-control", VmVolumeControl);
function instance($$self, $$props, $$invalidate) {
    let { $$slots: slots = {}, $$scope } = $$props;
    let __ref;
    let __mounted = false;
    const dispatch = createEventDispatcher();
    let { class: className } = $$props;
    let { style } = $$props;
    let { activeDuration = 2750 } = $$props;
    let { waitForPlaybackStart = false } = $$props;
    let { hideWhenPaused = false } = $$props;
    let { hideOnMouseLeave = false } = $$props;
    let { theme = undefined } = $$props;
    let { isMobile = false } = $$props;
    let { isLive = false } = $$props;
    let { isAudioView = false } = $$props;
    let { isVideoView = false } = $$props;
    const ref = () => __ref;
    const getWebComponent = () => __ref;
    onMount(() => {
        __mounted = true;
    });
    const onEvent = e => {
        e.stopPropagation();
        dispatch(e.type, e.detail);
    };
    function vm_default_controls_binding($$value) {
        binding_callbacks[$$value ? "unshift" : "push"](() => {
            __ref = $$value;
            $$invalidate(11, __ref);
        });
    }
    $$self.$$set = $$props => {
        if ("class" in $$props)
            $$invalidate(0, className = $$props.class);
        if ("style" in $$props)
            $$invalidate(1, style = $$props.style);
        if ("activeDuration" in $$props)
            $$invalidate(2, activeDuration = $$props.activeDuration);
        if ("waitForPlaybackStart" in $$props)
            $$invalidate(3, waitForPlaybackStart = $$props.waitForPlaybackStart);
        if ("hideWhenPaused" in $$props)
            $$invalidate(4, hideWhenPaused = $$props.hideWhenPaused);
        if ("hideOnMouseLeave" in $$props)
            $$invalidate(5, hideOnMouseLeave = $$props.hideOnMouseLeave);
        if ("theme" in $$props)
            $$invalidate(6, theme = $$props.theme);
        if ("isMobile" in $$props)
            $$invalidate(7, isMobile = $$props.isMobile);
        if ("isLive" in $$props)
            $$invalidate(8, isLive = $$props.isLive);
        if ("isAudioView" in $$props)
            $$invalidate(9, isAudioView = $$props.isAudioView);
        if ("isVideoView" in $$props)
            $$invalidate(10, isVideoView = $$props.isVideoView);
        if ("$$scope" in $$props)
            $$invalidate(14, $$scope = $$props.$$scope);
    };
    return [
        className,
        style,
        activeDuration,
        waitForPlaybackStart,
        hideWhenPaused,
        hideOnMouseLeave,
        theme,
        isMobile,
        isLive,
        isAudioView,
        isVideoView,
        __ref,
        ref,
        getWebComponent,
        $$scope,
        slots,
        vm_default_controls_binding
    ];
}
class DefaultControls extends SvelteComponent {
    constructor(options) {
        super();
        init(this, options, instance, create_fragment, safe_not_equal, {
            class: 0,
            style: 1,
            activeDuration: 2,
            waitForPlaybackStart: 3,
            hideWhenPaused: 4,
            hideOnMouseLeave: 5,
            theme: 6,
            isMobile: 7,
            isLive: 8,
            isAudioView: 9,
            isVideoView: 10,
            ref: 12,
            getWebComponent: 13
        });
    }
    $on(type, callback) {
        return super.$on(type, callback);
    }
    $set($$props) {
        super.$set($$props);
    }
    get ref() {
        return this.$$.ctx[12];
    }
    get getWebComponent() {
        return this.$$.ctx[13];
    }
}
export default DefaultControls;
//# sourceMappingURL=DefaultControls.js.map